export const CursorStyles = {
    cursor1: {
      position: 'absolute',
      top: 0,
      left: 0,
      height: '1rem',
      width: '1rem',
      background: '#2E9CCA', // Replace with the actual color value you have for --main-color
      pointerEvents: 'none',
      transform: 'translate(-50%, -50%)',
      borderRadius: '50%',
      zIndex: 10000,
      '&.active': { // Note how we target the active class
        height: '7rem',
        width: '7rem',
        opacity: 0.3,
      },
    },
    cursor2: {
      position: 'absolute',
      top: 0,
      left: 0,
      height: '4rem',
      width: '4rem',
      border: '0.1rem solid #2E9CCA', // Replace with the actual color value you have for --main-color
      pointerEvents: 'none',
      transform: 'translate(-50%, -50%)',
      borderRadius: '50%',
      zIndex: 10000,
      transition: '0.3s linear',
      '&.active': { // Note how we target the active class
        display: 'contents',
      },
    },
  };
  
  export default CursorStyles;